import { SAVE_SELECTED_CRED_ROW_DATA } from 'stores/redux/actions/types';
import hOReducer from '../common/reducer';

const reducer = hOReducer(SAVE_SELECTED_CRED_ROW_DATA);
export default reducer;
